/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFilePageBlock } from './DatabaseFilePageBlock';
import {
    DatabaseFilePageBlockFromJSON,
    DatabaseFilePageBlockFromJSONTyped,
    DatabaseFilePageBlockToJSON,
} from './DatabaseFilePageBlock';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseImagePageBlockType } from './DatabaseImagePageBlockType';
import {
    DatabaseImagePageBlockTypeFromJSON,
    DatabaseImagePageBlockTypeFromJSONTyped,
    DatabaseImagePageBlockTypeToJSON,
} from './DatabaseImagePageBlockType';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseImagePageBlock
 */
export interface DatabaseImagePageBlock extends DatabaseFilePageBlock {
    /**
     * 
     * @type {DatabaseImagePageBlockType}
     * @memberof DatabaseImagePageBlock
     */
    type?: DatabaseImagePageBlockType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseImagePageBlock
     */
    objectFit?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseImagePageBlock
     */
    objectPosition?: string;
    /**
     * FARBE UND GROESSE DES ICONS (Betreiber 13.09.2026: „Im
     * Baustein Bild aus Bibliothek kann ich ein Icon waehlen, aber
     * keine Farbe — hier fehlt der Farbpicker").
     * 
     * Ein Icon ist ein ZEICHEN einer Schriftart: In der Anzeige
     * steht `i { color: inherit; font-size: inherit; }` — es nimmt
     * also `--block-font-color` und `--block-font-size` des
     * Bausteins. Beide kamen bisher aus `fontColor`/`fontSize`, und
     * die gab es nur am TEXT-Baustein. Am Bildbaustein war damit
     * weder Farbe noch Groesse einstellbar; das Icon erschien in der
     * Schriftfarbe des Farbschemas und in Fliesstextgroesse.
     * 
     * Bei `type: IMAGE` ohne Bedeutung — ein Bild traegt seine
     * Farben selbst.
     * @type {string}
     * @memberof DatabaseImagePageBlock
     */
    fontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseImagePageBlock
     */
    fontSize?: DatabaseFontSizeEnum;
}

/**
 * Check if a given object implements the DatabaseImagePageBlock interface.
 */
export function instanceOfDatabaseImagePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseImagePageBlockFromJSON(json: any): DatabaseImagePageBlock {
    return DatabaseImagePageBlockFromJSONTyped(json, false);
}

export function DatabaseImagePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImagePageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFilePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabaseImagePageBlockTypeFromJSON(json['type']),
        'objectFit': !exists(json, 'objectFit') ? undefined : json['objectFit'],
        'objectPosition': !exists(json, 'objectPosition') ? undefined : json['objectPosition'],
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
    };
}

export function DatabaseImagePageBlockToJSON(value?: DatabaseImagePageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFilePageBlockToJSON(value),
        'type': DatabaseImagePageBlockTypeToJSON(value.type),
        'objectFit': value.objectFit,
        'objectPosition': value.objectPosition,
        'fontColor': value.fontColor,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
    };
}

